import React, { Fragment, Component } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import arrowDown from '../../images/arrow-down-black.svg';
// import './generalFaq.css';
import './faq.css';
import tempSchedule from '../../images/tempPaymentSchedule.png';

import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';

class NycDmvIssue extends Component {
  render() {
    const { status, email, history } = this.props;
    const faq_content = [
      {
        title: 'What is the DMV issue regarding?',
        text: (
          <p>
            We are currently experiencing an administrative issue with the
            NYS DMV that is affecting our NYC fleet documentation filing on
            their system. This means that all Autzu vehicles are unable to
            be driven during this time. <br />
            <br />
            To ensure that your driving experience is not affected or for
            any of our drivers to be suspended for driving an invalid
            vehicle, we have no choice but to cancel all driver bookings
            until we receive confirmation the issue is resolved.
          </p>
        )
      },
      {
        title: 'When can I expect this to be resolved?',
        text: (
          <p>
            We are making progress to resolve the issue with the DMV,
            however, as multiple stakeholders are involved, the timeline to
            resolve the issue quickly is out of our control. <br />
            <br />
            We expect to have a resolution soon, and we will provide an
            update to you as soon as possible. Please expect weekly email
            updates from with more information on our progress.
          </p>
        )
      },
      {
        title: 'Will I be charged for any cancellations?',
        text: (
          <p>
            You will not be charged for any booking cancellations due to
            this issue.
          </p>
        )
      },
      {
        title:
          'My cancelled bookings had a lower hourly rate than my new bookings, are you able to reinstate my previous hourly rate?',
        text: (
          <p>
            If a cancelled scheduled booking was originally made at a lower
            hourly rate compared to any new hourly booking rate, please
            contact us at 1-833-692-8898 or email us at nyc@autzu.com and
            we will be able to honor your original hourly rate.
          </p>
        )
      },
      {
        title:
          'Who can I talk to about this issue if I have more questions?',
        text: (
          <p>
            If you have any questions or concerns, please call us at
            1-833-692-8898 or email us at nyc@autzu.com.
          </p>
        )
      }
    ];
    return (
      <Fragment>
        <Helmet>
          <title>NYC DMV Issue | Autzu</title>
          <meta name="description" content="" />
        </Helmet>
        <section className="container">
          <div className="newFaq">
            <Header
              persistentTitle
              title="NYC DMV Issue"
              back
              onClick={() => {
                history.goBack();
              }}
            />
            {/* <div className="general-faq-header">
                <h2 className="general-faq-header--size">Payment FAQ</h2>
              </div> */}
            <div className="newFaq__body container">
              <div className="newFaq__container">
                <div className="newFaq__sidebar">
                  <SideBarContent status={status} signedIn={email} />
                </div>
                <div className="newFaq__content--container">
                  <div className="payment-faq__blurb--">
                    <div className="">
                      <div id="generalAccordion1">
                        <div
                          id="general1"
                          className="panel-collapse collapse in">
                          <div
                            className="panel-body"
                            style={{ padding: '0px' }}>
                            <div
                              className="panel-group"
                              id="generalAccordion2">
                              <div className="mini-faq__panel">
                                <strong>
                                  FINAL UPDATE 02/27 - BOOKING SYSTEM
                                  SUSPENDED:
                                </strong>{' '}
                                The Autzu booking system has been
                                temporarily suspended until further notice
                                as we are still working on resolving this
                                issue. Once resolved, we will be contacting
                                all drivers individually to reinstate their
                                bookings.
                              </div>
                              {faq_content.map((content, index) => (
                                <div
                                  key={`payment-faq-item${index}`}
                                  className="mini-faq__panel">
                                  <div
                                    className="mini-faq__heading collapsed"
                                    data-toggle="collapse"
                                    href={`#paymentFaq${index + 1}`}>
                                    <h4 className="mini-faq__panel--title">
                                      {content.title}{' '}
                                    </h4>
                                    {/* <img className="mini-faq__arrow" src={arrowDown} alt="arrow" /> */}
                                  </div>
                                  <div
                                    id={`paymentFaq${index + 1}`}
                                    className="panel-collapse">
                                    <div className="mini-faq__panel--body">
                                      {content.text}
                                      {content.image ? (
                                        <img
                                          className="banner__schedule--image"
                                          alt="schedule"
                                          src={tempSchedule}
                                          style={{
                                            display: 'block',
                                            width: '90%',
                                            margin: 'auto'
                                          }}
                                        />
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  }
}
export default withRouter(NycDmvIssue);



// WEBPACK FOOTER //
// ./src/components/Static/NycDmvIssue.js